// ═══════════════════════════════════════════════════════════════════
// LEAD LINK CONVERSIONS
// Clicks on WhatsApp and phone links are leads. Fire the matching
// Google Ads conversion and a GTM dataLayer event, while preserving
// the link's normal new-tab / same-tab behaviour.
// ═══════════════════════════════════════════════════════════════════
(function () {
    'use strict';

    const NAVIGATION_FALLBACK_MS = 1000;

    const LINK_TYPES = [
        {
            eventName: 'whatsapp_lead_click',
            fallbackName: 'whatsapp',
            conversionHandler: 'gtag_report_whatsapp_conversion',
            holdNavigation: true,
            matches: function (link) {
                try {
                    return new URL(link.href, window.location.href).hostname === 'wa.me';
                } catch (error) {
                    return false;
                }
            }
        },
        {
            eventName: 'call_lead_click',
            fallbackName: 'call',
            conversionHandler: 'gtag_report_call_conversion',
            holdNavigation: false,
            matches: function (link) {
                const href = (link.getAttribute('href') || '').trim().toLowerCase();
                return href.indexOf('tel:') === 0;
            }
        }
    ];

    function findLinkType(link) {
        for (let i = 0; i < LINK_TYPES.length; i += 1) {
            if (LINK_TYPES[i].matches(link)) return LINK_TYPES[i];
        }
        return null;
    }

    function ctaName(link, fallback) {
        const explicit = link.getAttribute('data-analytics-name') || '';
        const text = (link.textContent || '').replace(/\s+/g, ' ').trim();
        return (explicit || text || link.id || fallback).slice(0, 100);
    }

    function trackLead(link, type, redirectUrl) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: type.eventName,
                cta_name: ctaName(link, type.fallbackName),
                page_path: window.location.pathname || '/'
            });

            const handler = window[type.conversionHandler];
            if (typeof handler === 'function') {
                handler(redirectUrl);
            } else if (typeof redirectUrl !== 'undefined') {
                window.location.href = redirectUrl;
            }
        } catch (error) {
            if (typeof redirectUrl !== 'undefined') {
                window.location.href = redirectUrl;
            }
        }
    }

    document.addEventListener('click', function (event) {
        const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (!link) return;
        if (event.defaultPrevented || event.button !== 0) return;

        const type = findLinkType(link);
        if (!type) return;

        const modifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        const target = (link.getAttribute('target') || '').toLowerCase();
        const opensNewTab = target === '_blank' || modifiedClick;

        if (!type.holdNavigation || opensNewTab) {
            // Let the browser handle the link normally. WhatsApp keeps this
            // page alive in a new tab; tel: launches the dialer without
            // unloading the page.
            trackLead(link, type);
            return;
        }

        // Same-tab WhatsApp links: hold navigation until gtag's callback
        // runs, with a fallback so the link still works if analytics is blocked.
        event.preventDefault();
        trackLead(link, type, link.href);
        window.setTimeout(function () {
            window.location.href = link.href;
        }, NAVIGATION_FALLBACK_MS);
    });
})();
